export default __webpack_public_path__ + "static/media/suomenruotsalainen.4d68ec81.png";